"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOktonResponse = exports.isOktonApiError = exports.OktonApiError = void 0;
class OktonApiError extends Error {
    constructor(message, status, payload) {
        super(message);
        this.name = 'OktonApiError';
        this.status = status;
        this.code = payload === null || payload === void 0 ? void 0 : payload.code;
        this.details = payload === null || payload === void 0 ? void 0 : payload.details;
        this.payload = payload;
        Object.setPrototypeOf(this, OktonApiError.prototype);
    }
}
exports.OktonApiError = OktonApiError;
function isOktonApiError(error) {
    return error instanceof OktonApiError;
}
exports.isOktonApiError = isOktonApiError;
async function parseOktonResponse(response, fallbackMessage) {
    const payload = await response
        .json()
        .catch(() => ({}));
    if (!response.ok) {
        throw new OktonApiError(String(payload.message || fallbackMessage), response.status, payload);
    }
    return payload.data;
}
exports.parseOktonResponse = parseOktonResponse;
//# sourceMappingURL=index.js.map